import { EngagementType } from 'api';

import i18n from 'config/i18n';

export const getEngagementType = (type: EngagementType) => {
  switch (type) {
    case EngagementType.Comment:
      return i18n.t('network:comment');
    case EngagementType.CommentReaction:
      return i18n.t('network:commentReaction');
    case EngagementType.Quote:
      return i18n.t('network:quote');
    case EngagementType.Reaction:
      return i18n.t('network:reaction');
    case EngagementType.Retweet:
      return i18n.t('network:retweet');
    default:
      return null;
  }
};
